export enum enLocalEntrega {
    Loja = 1,
    Casa = 2
}